<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Banned Users"/>
      <mdb-card>
        <mdb-card-body class="text-left">
          <div v-if="banned.length == 0">
            No banned members.
          </div>
          <div>
            <small>Active members can be banned from the <router-link :to="'/group/' + currentGroup.vanityPath + '/members'">members</router-link> page.</small>
          </div>
          <mdb-tbl responsive striped v-if="banned.length>0">
            <mdb-tbl-head class="secondary-color">
              <tr>
                <th></th>
                <th></th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="(m,i) in banned">
                <td>
                  <avatar :avatar="m.avatar"/>
                  {{m.name}}
                </td>
                <td>
                  <mdb-btn @click="unban(m)" color="warning" icon="user-plus" rounded size="sm">Un-Ban</mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'
import Avatar from "../common/Avatar";

import {mdbBtn, mdbCard, mdbCardBody, mdbContainer, mdbTbl, mdbTblBody, mdbTblHead} from 'mdbvue';

export default {
    name: "group-banned",
    order: 1,
    components: {
      mdbContainer,
      mdbTbl, mdbTblHead, mdbTblBody, mdbBtn, mdbCard, mdbCardBody,
      Avatar,
      bannerSmall
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup
                       }),
    data() {
      return {
        banned: []
      }
    },
    mounted() {
      document.title = "Banned Users"
      if (!this.currentGroup) {
        api.groupBasics(this.$route.params.id, "public");
      }
      this.$store.dispatch("setExecuting", true)
      api.get("/member/banned/" + this.$route.params.id).then(
        (results) => {
          this.banned = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      unban(m) {
        this.$store.dispatch("setExecuting", true)
        api.post("/member/unBan/" + this.$route.params.id + "/?member=" + m.id).then(
          (results) => {
            let loc = this.banned.indexOf(m)
            this.banned.splice(loc,1)
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  };

</script>

